/**
 * Service centralisé de gestion du token d'authentification.
 * 
 * Centralise l'accès au token pour :
 * - Audit et traçabilité des accès
 * - Migration future vers HTTP-only cookies
 * - Éviter les accès directs à localStorage dispersés dans le code
 * 
 * Usage dans les composants React : préférer useAuth().getAuthHeader()
 * Usage dans les services/utilitaires : import { getToken, getAuthHeader } from './tokenService'
 */

const TOKEN_KEY = 'token';

let _memoryToken = null;

export function setToken(token) {
  _memoryToken = token;
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function getToken() {
  if (_memoryToken) return _memoryToken;
  const stored = localStorage.getItem(TOKEN_KEY);
  if (stored) _memoryToken = stored;
  return stored;
}

export function clearToken() {
  _memoryToken = null;
  localStorage.removeItem(TOKEN_KEY);
}

export function getAuthHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
